/* eslint-disable max-len */

import {observer} from 'mobx-react';
import {Spin} from 'antd';
import styled from 'styled-components';
import {LoadingOutlined} from '@ant-design/icons';
import {isNil} from 'lodash';
import {SidebarTooltip} from '../../../Common/SideBarTooltip/sidebarTooltip';
import {ReactNode} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faArrowDown, faArrowUp, faCheck} from '@fortawesome/pro-regular-svg-icons';
import styles from './style.module.scss';


interface Props {
  label: string;
  value?: number;
  tooltipLabel?: string | ReactNode;
  showTooltip?: boolean;
  loading?: boolean;
  min?: number;
  max?: number;
  headingData?:{
    h1: number;
    h2: number;
    h3: number;
    h1Min: number;
    h1Max: number;
    h2Min: number;
    h2Max: number;
    h3Min: number;
    h3Max: number;
  };
  linksData?:{
    internalLinks: number;
    externalLinks: number;
    internalLinksMin: number;
    internalLinksMax: number;
    externalLinksMin: number;
    externalLinksMax: number;
  };
}

export const SingleMetrics = observer(({label, value, tooltipLabel, showTooltip, loading, min, max, headingData, linksData}:Props) => {
  const secondAntIcon = <LoadingOutlined style={{color: '#7f4ead', marginLeft: '5px', fontSize: 10}} spin />;
  return <Container style={{alignItems: 'flex-start', justifyContent: 'flex-start', height: 'auto'}}>
    {label === 'Headings:' ?
      <>
        <StyledLable>{label}</StyledLable>
        {!loading ?
          showTooltip ?
            <>
              <div style={{marginLeft: 5, display: 'flex'}}>
                <SidebarTooltip arrowPointAtCenter={true}
                  placement='bottomRight'
                  title={tooltipLabel}>
                  <div>
                    <StyledIcon icon={(headingData.h1 < 1) ? faArrowUp : (headingData.h1 > 1) ? faArrowDown : faCheck} color={(headingData.h1 < 1) || (headingData.h1 > 1) ? '#FF8536' : '#1FAC47'}/>{' '} H1: {headingData.h1}
                    <RangeValues>0/1</RangeValues>
                  </div>
                  <div>
                    <StyledIcon icon={(headingData.h2 < headingData.h2Min) ? faArrowUp : (headingData.h2 > headingData.h2Max) ? faArrowDown : faCheck } color={(headingData.h2 < headingData.h2Min) || (headingData.h2 > headingData.h2Max) ? '#FF8536' : '#1FAC47'}/>{' '}H2: {headingData.h2}
                    <RangeValues>
                      {`${(!isNil(headingData.h2Min) && !isNil(headingData.h2Max)) ? `/` : ''} ${(!isNil(headingData.h2Min) && !isNil(headingData.h2Max)) ? `${headingData.h2Min}-${headingData.h2Max}` : ''}`}
                    </RangeValues>
                  </div>
                  <div>
                    <StyledIcon icon={(headingData.h3 < headingData.h3Min) ? faArrowUp : (headingData.h3 > headingData.h3Max) ? faArrowDown : faCheck } color={(headingData.h3 < headingData.h3Min) || (headingData.h3 > headingData.h3Max) ? '#FF8536' : '#1FAC47'}/>{' '}H3: {headingData.h3}
                    <RangeValues>
                      {`${(!isNil(headingData.h3Min) && !isNil(headingData.h3Max)) ? `/` : ''} ${(!isNil(headingData.h3Min) && !isNil(headingData.h3Max)) ? `${headingData.h3Min}-${headingData.h3Max}` : ''}`}
                    </RangeValues>
                  </div>
                </SidebarTooltip>
              </div>
            </> :
            <>
              <div style={{marginLeft: 5}}>
                <div>
                  <StyledIcon icon={(headingData.h1 < 1) ? faArrowUp : (headingData.h1 > 1) ? faArrowDown : faCheck} color={(headingData.h1 < 1) || (headingData.h1 > 1) ? '#FF8536' : '#1FAC47'}/>{' '} H1: {headingData.h1}
                  <RangeValues>0/1</RangeValues>
                </div>
                <div>
                  <StyledIcon icon={(headingData.h2 < headingData.h2Min) ? faArrowUp : (headingData.h2 > headingData.h2Max) ? faArrowDown : faCheck } color={(headingData.h2 < headingData.h2Min) || (headingData.h2 > headingData.h2Max) ? '#FF8536' : '#1FAC47'}/>{' '}H2: {headingData.h2}
                  <RangeValues>
                    {`${(!isNil(headingData.h2Min) && !isNil(headingData.h2Max)) ? `/` : ''} ${(!isNil(headingData.h2Min) && !isNil(headingData.h2Max)) ? `${headingData.h2Min}-${headingData.h2Max}` : ''}`}
                  </RangeValues>
                </div>
                <div>
                  <StyledIcon icon={(headingData.h3 < headingData.h3Min) ? faArrowUp : (headingData.h3 > headingData.h3Max) ? faArrowDown : faCheck } color={(headingData.h3 < headingData.h3Min) || (headingData.h3 > headingData.h3Max) ? '#FF8536' : '#1FAC47'}/>{' '}H3: {headingData.h3}
                  <RangeValues>
                    {`${(!isNil(headingData.h3Min) && !isNil(headingData.h3Max)) ? `/` : ''} ${(!isNil(headingData.h3Min) && !isNil(headingData.h3Max)) ? `${headingData.h3Min}-${headingData.h3Max}` : ''}`}
                  </RangeValues>
                </div>
              </div>
            </> :
          <Spin indicator={secondAntIcon}/> }
      </> :
      label === 'Links:' ?
        <>
          <StyledLable>{label}</StyledLable>
          {!loading ?
            showTooltip ?
              <>
                <div style={{marginLeft: 5, display: 'flex'}}>
                  <SidebarTooltip
                    arrowPointAtCenter={true}
                    placement='bottomRight'
                    overlayClassName={styles.linkToolTip}
                    title={tooltipLabel}>
                    <div>
                      <StyledIcon icon={(linksData.internalLinks < linksData.internalLinksMin) ? faArrowUp : (linksData.internalLinks > linksData.internalLinksMax) ? faArrowDown : faCheck} color={(linksData.internalLinks < linksData.internalLinksMin) || (linksData.internalLinks > linksData.internalLinksMax) ? '#FF8536' : '#1FAC47'}/>{' '} Internal: {linksData.internalLinks}
                      <RangeValues>
                        {`${(!isNil(linksData.internalLinksMin) && !isNil(linksData.internalLinksMax)) ? `/` : '/'} ${(!isNil(linksData.internalLinksMin) && !isNil(linksData.internalLinksMax)) ? `${linksData.internalLinksMin}-${linksData.internalLinksMax}` : ''}`}
                      </RangeValues>
                    </div>
                    <div>
                      <StyledIcon icon={(linksData.externalLinks < linksData.externalLinksMin) ? faArrowUp : (linksData.externalLinks > linksData.externalLinksMax) ? faArrowDown : faCheck} color={(linksData.externalLinks < linksData.externalLinksMin) || (linksData.externalLinks > linksData.externalLinksMax) ? '#FF8536' : '#1FAC47'}/>{' '}External: {linksData.externalLinks}
                      <RangeValues>
                        {`${(!isNil(linksData.externalLinksMin) && !isNil(linksData.externalLinksMax)) ? `/` : ''} ${(!isNil(linksData.externalLinksMin) && !isNil(linksData.externalLinksMax)) ? `${linksData.externalLinksMin}-${linksData.externalLinksMax}` : ''}`}
                      </RangeValues>
                    </div>
                  </SidebarTooltip>
                </div>
              </> :
              <div style={{marginLeft: 5}}>
                <Dot isWithinRecomendedRange={value >= min && value <= max}/>
                {value}
                <RangeValues>
                  {`${(!isNil(min) && !isNil(max)) ? `/` : ''} ${(!isNil(min) && !isNil(max)) ? `${min}-${max}` : ''}`}
                </RangeValues>
              </div> :
            <Spin indicator={secondAntIcon}/> }
        </> :
        <>
          <StyledLable>{label}</StyledLable>
          {!loading ?
            showTooltip ?
              <div style={{marginLeft: 5}}>
                <SidebarTooltip arrowPointAtCenter={true}
                  placement='bottomLeft'
                  title={tooltipLabel}>
                  <StyledIcon icon={(value < min) ? faArrowUp : (value > max) ? faArrowDown : faCheck} color={(value < min) || (value > max) ? '#FF8536' : '#1FAC47'}/>
                  {value}
                  <RangeValues>
                    {`${(!isNil(min) && !isNil(max)) ? `/` : ''} ${(!isNil(min) && !isNil(max)) ? `${min}-${max}` : ''}`}
                  </RangeValues>
                </SidebarTooltip>
              </div> :
              <div style={{marginLeft: 5}}>
                <Dot isWithinRecomendedRange={value >= min && value <= max}/>
                {value}
                <RangeValues>
                  {`${(!isNil(min) && !isNil(max)) ? `/` : ''} ${(!isNil(min) && !isNil(max)) ? `${min}-${max}` : ''}`}
                </RangeValues>
              </div> :
            <Spin indicator={secondAntIcon}/> }
        </>
    }
  </Container>;
});


const Container = styled.div`
  font-size: 12px;
  display: flex;
  align-items: center;
  color: #e8e8e8;
  cursor: default;
  height: 18px;
`;
const Dot = styled.div<{isWithinRecomendedRange?: boolean}>`
  width: 4px;
  height: 4px;
  background-color: ${p => p.isWithinRecomendedRange ? '#1FAC47' : '#F44343'};
  border-radius: 100%;
  display: inline-block;
  margin-bottom: 2px;
  margin-left: 2px;
  margin-right: 3px;
`;
const RangeValues = styled.div`
  color: #A3A4A4 !important;
  font-size: 10px;
  display: inline-flex;
  margin-left: 2px;

  @media screen and (max-width: 1400px) {
    font-size: 8px;
  }
`;
const StyledLable = styled.p`
  margin-bottom: 0px;
  width: 72px;
  text-align: end;
  margin-right: 5px;
  color: #E8E8E8;
`;
const StyledIcon = styled(FontAwesomeIcon)`
  width: 12px;
`;
